module.exports = __webpack_public_path__ + "static/media/rekrutacja-2024.853f7f88.jpg";